import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer"; 
import { Breadcrumb } from "../components/Breadcrumb";
import ReadyToPlan from "../components/ReadyToPlan";

export default function IndustriesWeServe() {
    return (
        <div style={{ padding: "160px 0 0 0" }}>
            {/* <Breadcrumb currentName={"People We Serve"} currentParentName={"People We Serve"} /> */}
            {/* Introduction Section */}
            <FadeInSection >
                <section className="content-section py-5" style={{ background: "var(--light-bg)" }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6 }}
                                    className="text-center mb-5"
                                >
                                    <h2 className="display-5 fw-bold mb-4" style={{ color: "var(--heading)" }}>
                                        Personalized Financial Planning
                                    </h2>
                                    <p className="lead fs-4" style={{ color: "var(--text)" }}>
                                        At <strong style={{ color: "var(--primary)" }}>SAG Financials</strong>, we understand that financial planning isn't just about numbers — it's about people, and the lives they're building.
                                    </p>
                                </motion.div>

                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <motion.div
                                            initial={{ opacity: 0, x: -20 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            transition={{ duration: 0.6, delay: 0.2 }}
                                            className="card h-100 border-1 shadow-sm"
                                            style={{ background: "var(--white)", borderColor:'var(--secondary)' }}
                                        >
                                            <div className="card-body p-4">
                                                <div className="d-flex align-items-center mb-3">
                                                    <div
                                                        className="rounded-circle p-3 me-3 d-flex align-items-center justify-content-center"
                                                        style={{
                                                            background: "var(--primary)",
                                                            width: '60px',
                                                            height: '60px'
                                                        }}
                                                    >
                                                        <span className="text-white fs-5">📊</span>
                                                    </div>
                                                    <h5 style={{ color: "var(--heading)", margin: 0 }}>Why Industry-Specific Planning?</h5>
                                                </div>
                                                <p style={{ color: "var(--text)" }}>
                                                    Each profession comes with unique opportunities, risks, income patterns, and life goals.
                                                    We provide <strong>personalized financial strategies</strong> tailored to your specific needs.
                                                </p>
                                            </div>
                                        </motion.div>
                                    </div>
                                    <div className="col-md-6">
                                        <motion.div
                                            initial={{ opacity: 0, x: 20 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            transition={{ duration: 0.6, delay: 0.3 }}
                                            className="card h-100 border-1 shadow-sm"
                                            style={{ background: "var(--white)", borderColor:'var(--secondary)' }}
                                        >
                                            <div className="card-body p-4">
                                                <div className="d-flex align-items-center mb-3">
                                                    <div
                                                        className="rounded-circle p-3 me-3 d-flex align-items-center justify-content-center"
                                                        style={{
                                                            background: "var(--secondary)",
                                                            width: '60px',
                                                            height: '60px'
                                                        }}
                                                    >
                                                        <span className="text-dark fs-5">🎯</span>
                                                    </div>
                                                    <h5 style={{ color: "var(--heading)", margin: 0 }}>Our Approach</h5>
                                                </div>
                                                <p style={{ color: "var(--text)" }}>
                                                    We consider your income structure, tax benefits, risk exposure, and retirement needs
                                                    to offer realistic, relevant, and customized planning.
                                                </p>
                                            </div>
                                        </motion.div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </FadeInSection>

            {/* Industries Grid Section */}
            <section className="industries-list py-5" style={{ background: "var(--white)" }}>
                <div className="container">
                    <FadeInSection>
                        <div className="text-center mb-5">
                            <h2 className="display-5 fw-bold mb-3" style={{ color: "var(--heading)" }}>
                                Who We Serve 
                            </h2>
                            <p className="lead" style={{ color: "var(--text)" }}>
                                Expert financial guidance tailored to your profession and lifestyle
                            </p>
                        </div>
                    </FadeInSection>

                    <div className="row g-4">
                        {industries.map((item, idx) => (
                            <IndustryCard key={idx} item={item} index={idx} />
                        ))}
                    </div>
                </div>
            </section>

            {/* Common Goals Section */}
            <FadeInSection>
                <section className="py-5" style={{ background: "var(--light-bg)" }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <motion.div
                                    initial={{ opacity: 0, x: -30 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.7 }}
                                >
                                    <h2 className="display-6 fw-bold mb-4" style={{ color: "var(--heading)" }}>
                                        Common Goals We Help All Clients With
                                    </h2>
                                    <ul className="custom-list mt-3">
                                        {commonGoals.map((goal, index) => (
                                            <motion.li
                                                key={index}
                                                initial={{ opacity: 0, x: -20 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                                style={{ color: "var(--text)" }}
                                            >
                                                {goal}
                                            </motion.li>
                                        ))}
                                    </ul>
                                </motion.div>
                            </div>
                            <div className="col-lg-6">
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.7 }}
                                    className="text-center"
                                >
                                    <div
                                        className="rounded-4 p-5 mx-auto shadow"
                                        style={{
                                            background: `linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%)`,
                                            maxWidth: '400px'
                                        }}
                                    >
                                        <h4 className="text-white mb-4 fw-bold">Your Financial Journey</h4>
                                        <div className="progress-steps text-white">
                                            <div className="step completed">Assessment</div>
                                            <div className="step completed">Strategy</div>
                                            <div className="step completed">Implementation</div>
                                            <div className="step">Growth & Review</div>
                                        </div>
                                    </div>
                                </motion.div>
                            </div>
                        </div>
                    </div>
                </section>
            </FadeInSection>

            {/* Why Choose Us Section */}
            <FadeInSection>
                <section
                    className="why-choose py-5 text-white"
                    style={{
                        background: `linear-gradient(135deg, var(--highlight) 0%, var(--accent) 100%)`
                    }}
                >
                    <div className="container">
                        <div className="text-center mb-5">
                            <h2 className="display-5 fw-bold mb-3">Why SAG Financials ?</h2>
                        </div>
                        <div className="row g-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div
                                    key={index}
                                    className="col-md-6 col-lg-3"
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                >
                                    <div className="text-center p-4 h-100">
                                        <div
                                            className="icon-wrapper rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                                            style={{
                                                width: '80px',
                                                height: '80px',
                                                background: 'rgba(255,255,255,0.2)',
                                                fontSize: '2rem'
                                            }}
                                        >
                                            {item.icon}
                                        </div>
                                        <h5 className="mb-3 fw-bold">{item.title}</h5>
                                        <p className="small opacity-90">{item.description}</p>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
            </FadeInSection>

            <ReadyToPlan />

            <style jsx>{`
        .custom-list {
          list-style: none;
          padding-left: 0;
        }
        
        .custom-list li {
          position: relative;
          padding-left: 2rem;
          margin-bottom: 0.75rem;
          color: var(--text);
        }
        
        .custom-list li:before {
          content: '✓';
          position: absolute;
          left: 0;
          color: var(--primary);
          font-weight: bold;
        }
        
        .progress-steps .step {
          padding: 0.75rem 1rem;
          margin: 0.5rem 0;
          border-radius: 2rem;
          background: rgba(255,255,255,0.2);
          position: relative;
          font-weight: 500;
        }
        
        .progress-steps .step.completed {
          background: rgba(255,255,255,0.3);
        }
        
        .progress-steps .step:after {
          content: '→';
          position: absolute;
          right: 1rem;
          font-weight: bold;
        }
        
        .progress-steps .step:last-child:after {
          content: '';
        }
        
        .card-hover-effect {
          transition: all 0.3s ease;
          border: 1px solid transparent;
        }
        
        .card-hover-effect:hover {
          transform: translateY(-5px);
          border-color: var(--primary);
          box-shadow: 0 10px 30px rgba(0, 119, 125, 0.1);
        }
      `}</style>
        </div>
    );
}

// Animation Components
const FadeInSection = ({ children }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView({
        threshold: 0.1,
        triggerOnce: true
    });

    useEffect(() => {
        if (inView) {
            controls.start('visible');
        }
    }, [controls, inView]);

    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            transition={{ duration: 0.6 }}
            variants={{
                visible: { opacity: 1, y: 0 },
                hidden: { opacity: 0, y: 50 }
            }}
        >
            {children}
        </motion.div>
    );
};

const IndustryCard = ({ item, index }) => {
    return (
        <div className="col-md-6 col-lg-4">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="card h-100 shadow-sm border-1 card-hover-effect"
                style={{ background: "var(--white)",borderColor:'var(--secondary)' }}
            >
                <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-3">
                        <div
                            className="rounded-circle p-2 me-3 d-flex align-items-center justify-content-center"
                            style={{
                                background: "var(--light-bg)",
                                width: '50px',
                                height: '50px'
                            }}
                        >
                            <span className="fs-5">{item.icon}</span>
                        </div>
                        <h5 className="card-title mb-0 fw-bold" style={{ color: "var(--heading)" }}>
                            {item.title}
                        </h5>
                    </div>
                    <ul className="custom-list small mt-2 d-none">
                        {item.points.map((p, i) => (
                            <li key={i} style={{ color: "var(--text)" }}>{p}</li>
                        ))}
                    </ul>
                </div>
            </motion.div>
        </div>
    );
};

// Data Arrays
const industries = [
    {
        icon: "👨💼",
        title: "Salaried Professionals",
        points: [
            "Plan for long-term goals (retirement, child's education, buying a home)",
            "Save taxes through smart investments",
            "Build emergency funds and short-term savings",
            "Understand company benefits like PF and ESOPs",
            "Supplement employer insurance with personal protection",
        ],
    },
    {
        icon: "🧑⚕️",
        title: "Doctors & Healthcare Professionals",
        points: [
            "Manage irregular or cash-based income flows",
            "Plan for clinic investments and equipment upgrades",
            "Choose the right insurance for professional risks",
            "Plan for children's education and retirement",
            "Create multi-goal investment portfolios",
        ],
    },
    {
        icon: "💼",
        title: "Business Owners & Entrepreneurs",
        points: [
            "Separate business and personal financial goals",
            "Build emergency reserves and cash flow stability",
            "Save tax under business-relevant sections",
            "Secure families with comprehensive insurance",
            "Plan for long-term wealth creation and exit strategies",
        ],
    },
    {
        icon: "👩🎓",
        title: "Women Professionals & Homemakers",
        points: [
            "Encourage financial independence and literacy",
            "Create goal-based plans for education and home",
            "Offer health insurance specific to women's needs",
            "Help create wealth with single income",
            "Support with financial clarity in life transitions",
        ],
    },
    {
        icon: "📱",
        title: "Freelancers & Consultants",
        points: [
            "Build consistent saving habits with variable income",
            "Plan for taxes in freelance structures",
            "Set up long-term investments suited to cash flow",
            "Secure with individual term and health insurance",
            "Plan for lean periods or industry downturns",
        ],
    },
    {
        icon: "👨🌾",
        title: "NRIs & Returning Indians",
        points: [
            "Manage India-based assets and income",
            "Navigate taxation for NRI investments",
            "Choose NRE/NRO investment options",
            "Plan for retirement or relocation to India",
            "Insurance and protection across borders",
        ],
    },
];

const commonGoals = [
    "Build and grow investment portfolios (SIPs, mutual funds, FDs, bonds)",
    "Choose right-sized insurance coverage (life, health, accident)",
    "Plan efficient tax-saving strategies",
    "Prepare for education, marriage, home purchase, or travel",
    "Structure retirement income and succession planning",
    "Access loan advisory when liquidity is needed",
];

const whyChooseUs = [
    {
        icon: "📊",
        title: "22+ Years Experience",
        description: "Trusted Expertise in financial service industry."
    },
    {
        icon: "🏆",
        title: "Certified Professionals",
        description: "AMFI, IRDA & NISM certified with proven track record of success"
    },
    {
        icon: "💻",
        title: "Digital Convenience",
        description: "Personalized service with the ease of digital tools and platforms"
    },
    {
        icon: "👩💼",
        title: "Women-Led Excellence",
        description: "Founded by Shepra Anand with empathy, integrity, and clarity"
    }
];

